<!-- Popup Alert Overlay -->

@if (popupAlerts.length > 0) {
<div class="popup-overlay" (click)="closePopup(popupAlerts[0].id)">
  @for (alert of popupAlerts; track alert.id) {
  <div class="popup-container" [ngClass]="getPopupClass(alert)" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    @if (alert.showCloseButton !== false) {
    <button class="popup-close" (click)="closePopup(alert.id)" aria-label="Close popup">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M15 5L5 15M5 5L15 15"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
    }
    <!-- Icon Container -->
    <div class="popup-icon-container">
      <div class="popup-icon" [ngClass]="getIconClass(alert)">
        <!-- Success Icon -->
        @if (alert.type === 'success') {
        <img [src]="IMAGES.IMAGES.SUCCESS" alt="Success" class="popup-icon-image" />
        } @if (alert.type === 'error') {
        <!-- Error Icon -->
        <img [src]="IMAGES.IMAGES.ERROR" alt="Error" class="popup-icon-image" />
        }
      </div>
    </div>

    <!-- Content -->
    <div class="popup-content">
      <h2 class="popup-title">{{ alert.title }}</h2>
      <p class="popup-message">{{ alert.message }}</p>
    </div>

    <!-- Actions -->
    <div class="popup-actions">
      <button class="popup-btn secondary" (click)="executeAction(alert.secondaryAction.action)">
        {{ alert.secondaryAction.text }}
      </button>
      <button class="popup-btn primary" (click)="executeAction(alert.primaryAction.action)">
        {{ alert.primaryAction.text }}
      </button>
    </div>
  </div>
  }
</div>
}
